import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { locations } from "@/mocks/ppcare";

export default function LocationsSection() {
  return (
    <section id="our-locations" className="bg-background-50 py-16 md:py-24">
      <div className="container">
        <Reveal>
          <SectionHeading
            eyebrow="We Have Five Offices Just for You"
            title={
              <>
                Our Convenient{" "}
                <span className="font-script text-accent-500">Locations</span>
              </>
            }
          />
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {locations.map((location, index) => (
            <Reveal key={location.city} delay={index * 100}>
              <div className="flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50">
                <div className="h-52 w-full overflow-hidden">
                  <img
                    src={location.image}
                    alt={`${location.city} office interior`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>

                <div className="flex flex-1 flex-col p-6">
                  <h3 className="text-xl font-bold text-foreground-950">{location.city}</h3>

                  <div className="mt-3 text-sm leading-relaxed text-foreground-600">
                    {location.addressLines.map((line) => (
                      <p key={line}>{line}</p>
                    ))}
                  </div>

                  <a
                    href={location.directionsHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-4 inline-flex w-fit items-center gap-2 whitespace-nowrap text-sm font-semibold text-primary-600 transition-colors hover:text-primary-700"
                  >
                    <i className="ri-navigation-line" />
                    Get Directions
                  </a>

                  <a
                    href={location.phoneHref}
                    className="mt-4 inline-flex w-fit items-center gap-2 whitespace-nowrap text-sm font-semibold text-foreground-900 transition-colors hover:text-primary-600"
                  >
                    <i className="ri-phone-line" />
                    {location.phone}
                  </a>

                  <div className="mt-5 border-t border-background-200 pt-5">
                    <p className="text-sm font-bold text-foreground-950">Hours of Operation</p>
                    <div className="mt-2 flex flex-col gap-1">
                      {location.hours.map((hour) => (
                        <p key={hour.days} className="text-sm text-foreground-700">
                          <span className="font-semibold text-foreground-900">{hour.days}</span>{" "}
                          {hour.time}
                        </p>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}